export default __webpack_public_path__ + "static/media/commerce001.32960592.png";